import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);
const  scrollBehavior = (to, from, savedPosition) => {
    if (savedPosition && to.meta.keepAlive) {
      return savedPosition;
    }
    return { left: 0, top:0 };
}
export default new Router({
  mode: "history",
  routes: [
    {
      path: '/',
      redirect: 'logistics-single'
    },
    {
      path: '/',
      component: () => import('../components/common/Base.vue'),
      meta: {
        title: '公共部分'
      },
      children: [
        {
          path: '/express-single',
          component: () => import('../components/page/ExpressSingle.vue'),
          meta: {
            title: '单个寄件'
          }
        },
        {
          path: '/express-batch',
          component: () => import('../components/page/ExpressBatch.vue'),
          meta: {
            title: '批量寄件'
          }
        },
		{
		  path: '/logistics-single',
		  component: () => import('../components/page/LogisticsSingle.vue'),
		  meta: {
		    title: '单个寄件'
		  }
		},
		{
		  path: '/all-waybills',
		  component: () => import('../components/page/AllWaybills.vue'),
		  meta: {
		    title: '全部运单'
		  }
		},
		{
		  path: '/order-detail',
		  component: () => import('../components/page/OrderDetail.vue'),
		  meta: {
		    title: '全部运单'
		  }
		},
		{
		  path: '/staging-waybills',
		  component: () => import('../components/page/StagingOrder.vue'),
		  meta: {
		    title: '暂存运单'
		  }
		},
		{
		  path: '/subscribe-service',
		  component: () => import('../components/page/SubscribeService.vue'),
		  meta: {
		    title: '服务预约'
		  }
		},
		{
		  path: '/select-service',
		  component: () => import('../components/page/SelectService.vue'),
		  meta: {
		    title: '选择服务'
		  }
		},
		{
		  path: '/workorder-list',
		  component: () => import('../components/page/WorkorderList.vue'),
		  meta: {
		    title: '工单列表'
		  }
		},
		{
		  path: '/service-detail',
		  component: () => import('../components/page/ServiceDetail.vue'),
		  meta: {
		    title: '工单详情'
		  }
		},
		
        {
          path: '/logistics-single',
          component: () => import('../components/page/LogisticsSingle.vue'),
          meta: {
            title: '单个寄件'
          }
        },
        {
          path: '/all-waybills',
          component: () => import('../components/page/AllWaybills.vue'),
          meta: {
            title: '全部运单'
          }
        },
        {
          path: '/order-detail',
          component: () => import('../components/page/OrderDetail.vue'),
          meta: {
            title: '全部运单'
          }
        },
        {
          path: '/staging-waybills',
          component: () => import('../components/page/StagingOrder.vue'),
          meta: {
            title: '暂存运单'
          }
        },
        {
          path: '/subscribe-service',
          component: () => import('../components/page/SubscribeService.vue'),
          meta: {
            title: '服务预约'
          }
        },
        {
          path: '/select-service',
          component: () => import('../components/page/SelectService.vue'),
          meta: {
            title: '选择服务'
          }
        },
        {
          path: '/my-account',
          component: () => import('../components/page/MyAccount.vue'),
          meta: {
            title: '我的账户'
          }
        },
        {
          path: '/account-detail',
          component: () => import('../components/page/AccountDetail.vue'),
          meta: {
            title: '我的账户'
          }
        },
        {
          path: '/settlement_invoicing',
          component: () => import('../components/page/SettlementInvoicing.vue'),
          meta: {
            title: '结算开票'
          }
        },
		{
		  path: '/data-board',
		  component: () => import('../components/page/DataBoard.vue'),
		  meta: {
		    title: '数据看板'
		  }
		},
		{
		  path: '/modify-password',
		  component: () => import('../components/page/ModifyPassword.vue'),
		  meta: {
		    title: '修改密码'
		  }
		}
      ]
    },
    {
      path: '/payment',
      component: () => import('../components/common/payment.vue'),
      meta: {
        title: '支付'
      }
    },
    {
      path: '/login',
      component: () => import('../components/page/Login.vue')
    },
    {
      path: '/error',
      component: () => import('../components/page/Error.vue')
    },
    {
      path: '/404',
      component: () => import('../components/page/404.vue')
    }
  ],
  scrollBehavior
});




// WEBPACK FOOTER //
// ./src/router/index.js